/*
 *
 * Date: 2025
 * Description: Main components for part display
 * Author: Philippe Leroux @SKITSC
 *
 */

//Modules
import { Box , Typography , Grid, IconButton, Collapse, Skeleton, Tooltip } from "@mui/material";
import { ReactElement, useState } from "react";

//Interfaces
import { i_part_card_complete_props } from "../../interfaces/display.interfaces";

//Components
import SubPart from "./sub.part.card";

//Icons
import PageviewIcon from '@mui/icons-material/Pageview';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { Update } from "@mui/icons-material";

//Hooks
import { useViewModal } from "../../context/view.modal.context";
import { useFitModal } from "../../context/fit.modal.context";


const PartCard = ( props : i_part_card_complete_props ) : ReactElement => {
    const [ hide , setHide ] = useState<boolean>(true)
    const { showPartModal } = useViewModal();
    const { showFilteredModal } = useFitModal();
    const C = props.part
    const V = props.part.vendors
    const formatCat = ( arr  : string[] ) => {
        try{
        var mainCat : string = arr[1]
        var subCat : string = arr[2]
        if(arr[2] !== arr[3]){
            subCat +=' / '+ arr[3]
        }
        return mainCat + ' / ' + subCat
        }catch(err){
            console.log('Error in formatCat', err)
            return 'Error in category formatting'
        }
    }
    return(
        
        <Box sx={{ width : '100%' ,}}>
            {props.rendering ? (
                <Skeleton sx={{ height: 190 }} animation="wave" variant="rectangular" />
            ) :
        <Box>
            <Box sx={{ border : props.in ? "2px solid lime" : '1px solid #EAECF0' , padding : 1 }}>
                    <Grid container>
                        <Grid size={{ xl : 2 , lg : 2.5, md : 3, xs : 12}}>
                            <Box sx={{ width: 200, height: 160, display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden' }} onClick={() => showPartModal(C.path)} >
                                <Box component="img" sx={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain'}} src={props.path + C.path} />
                            </Box>
                        </Grid>
                        <Grid size={{ xl : 4 , lg : 4.0 , md : 4.0, xs : 12}} p={1}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: 140}}>
                                <Typography sx={{ textDecoration : 'underline' , fontWeight : 800}}>Parts link : {C.sku}</Typography>
                                <Typography sx={{ fontSize :14}}>{C.description}</Typography>
                                <Typography sx={{ fontWeight : '700'}}>  {V.avatar.length > 0 ? formatCat(V.avatar[0].categories) : "No category found"}</Typography>
                            </Box>
                        </Grid>
                        <Grid size={{ xl : 5 ,md : 4, xs : 12}}>
                            {}
                            <Box sx={{ display : 'flex' , flexDirection : 'column' , justifyContent: 'space-between', height: 140}}>
                                {V.tiger.length > 0 &&
                                   <SubPart price={V.tiger[0].price} stock={V.tiger[0].stock} time={V.tiger[0].timestamp} type={'Tiger'} />
                                }
                                {V.lkq.length > 0 &&
                                   <SubPart price={V.lkq[0].price} stock={V.lkq[0].stock} time={V.lkq[0].timestamp} type={'Lkq'} />
                                }
                                {V.rockauto.length > 0 &&
                                    <SubPart price={V.rockauto[0].price} stock={V.rockauto[0].stock} time={V.rockauto[0].timestamp} type={'Rockauto'} />
                                }
                                {V.atpac.length > 0 &&
                                    <SubPart price={V.atpac[0].price} stock={V.atpac[0].stock} time={V.atpac[0].timestamp} type={'Atpac'} />
                                }
                                {V.avatar.length > 0 &&
                                   <SubPart price={V.avatar[0].price} stock={V.avatar[0].stock} time={V.avatar[0].timestamp} type={'Avatar'} />
                                }
                                {V.moneydex.length > 0 &&
                                   <SubPart price={V.moneydex[0].price} stock={V.moneydex[0].stock} time={V.moneydex[0].timestamp} type={'Moneydex'} />
                                }
                            </Box>
                        </Grid>
                       
                        <Grid size={{ xl: 0.5 , lg : 0.5, md : 0.5, xs : 12 }} sx={{ alignContent : 'space-evenly'}}>

                                <Box sx={{ display : 'flex' , justifyContent : 'space-between' }}>                            
                                    {props.type === 'catalog' &&
                                    <IconButton onClick={() => props.addPart(C)}>
                                        <AddShoppingCartIcon color={'primary'} />
                                    </IconButton>
                                     }
                                    <IconButton onClick={() => setHide(hide ? false : true)}>
                                        {hide ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                                    </IconButton>
                                </Box>
                           
                        </Grid>
                    </Grid>
            </Box>
            <Collapse in={!hide} timeout="auto">
                <Box sx={{ border : '1px solid #EAECF0' , padding : 2 }}>
                    <Grid container>
                        <Grid size={{ xs : 1 }}>
                            <IconButton onClick={() => showFilteredModal(C.car_fit , props.filter)}>
                                <DirectionsCarIcon color={'primary'} ></DirectionsCarIcon>
                            </IconButton>
                        </Grid>
                        <Grid size={{ xs : 1}}>
                            <Tooltip title={'Could be a search to the latest price..'}>
                                <IconButton onClick={() => props.callback(props.part , 'search')}>
                                    <PageviewIcon color={'primary'} />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                        <Grid size={{ xs : 1 }}>
                            <Tooltip title={'What ever we need here'}>
                                <IconButton color={'primary'}><Update/></IconButton>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </Box>
            </Collapse>
        </Box>
    }
    </Box>
    )
}

export default PartCard;